import { omit as _omit } from 'lodash';

import types from './actionTypes';

const uploaderReducer = (state = {}, action) => {
    switch (action.type) {
        case types.CREATE_FILES_POOL: {
            return {
                ...state,
                [action.payload.poolName]: action.payload.initialState,
            };
        }
        case types.REMOVE_FILES_POOL: {
            return _omit(state, action.payload.poolName);
        }
        default:
            return state;
    }
};

const fileReducer = (state = {}, action) => {
    switch (action.type) {
        case types.ADD_FILE: {
            const { filesPool } = action.meta;
            const data = state[filesPool];

            const fileList = [...data];

            fileList.push(action.payload);

            return {
                ...state,
                [filesPool]: fileList,
            };
        }
        case types.SET_FILE: {
            const { filesPool } = action.meta;
            const data = state[filesPool];

            const fileList = data.map(file => {
                if (file.uid === action.payload.uid) {
                    return action.payload;
                }
                return file;
            });

            return {
                ...state,
                [filesPool]: fileList,
            };
        }
        case types.REMOVE_FILE: {
            const { filesPool } = action.meta;
            const data = state[filesPool];

            const { id } = action.payload;

            const fileList = data.filter(file => file.uid !== id);

            return {
                ...state,
                [filesPool]: fileList,
            };
        }
        default:
            return state;
    }
};

export default (state = {}, action) => {
    if ([types.CREATE_FILES_POOL, types.REMOVE_FILES_POOL].includes(action.type)) {
        return uploaderReducer(state, action);
    }
    return fileReducer(state, action);
};
